/**
 * Плотности при н.у. и плотности наливной жидкости — справочные.
 * Коэффициенты сжимаемости Z приведены при ~20 °C, погрешность порядка ±2–3 %.
 *
 * Все три газа в баллоне остаются газом: критические температуры (−118, −122
 * и −147 °C) намного ниже комнатной, жидкой фазы при 150–200 бар не возникает.
 * Поэтому нормы наполнения по массе, как у углекислоты, тут неприменимы.
 */
export const GASES = [
  {
    id: 'oxygen',
    name: 'Кислород',
    formula: 'O₂',
    density0: 1.429,
    bulk: { density: 1.141, at: '−183 °C' },
    color: '#2e9bd6',
    colorDark: '#4fb3e8',
    ink: 'light',
    z: [
      [0, 1], [50, 0.977], [100, 0.962], [150, 0.958],
      [200, 0.966], [250, 0.983], [300, 1.007],
    ],
  },
  {
    id: 'argon',
    name: 'Аргон',
    formula: 'Ar',
    density0: 1.784,
    bulk: { density: 1.3954, at: '−186 °C' },
    color: '#3f8f5c',
    colorDark: '#56ab74',
    ink: 'light',
    z: [
      [0, 1], [50, 0.971], [100, 0.951], [150, 0.945],
      [200, 0.954], [250, 0.974], [300, 1.003],
    ],
  },
  {
    id: 'nitrogen',
    name: 'Азот',
    formula: 'N₂',
    density0: 1.2505,
    bulk: { density: 0.8085, at: '−196 °C' },
    color: '#39424e',
    colorDark: '#6b7785',
    ink: 'light',
    z: [
      [0, 1], [50, 0.991], [100, 0.995], [150, 1.011],
      [200, 1.036], [250, 1.066], [300, 1.101],
    ],
  },
]

export const GAS_BY_ID = Object.fromEntries(GASES.map((g) => [g.id, g]))

/** Вместимости баллонов под заправку, л */
export const CYLINDER_SIZES = [40, 50]

/** Давление заправки, бар */
export const FILL_PRESSURES = [150, 200]
